import React from "react";
import Skeleton from "react-loading-skeleton";
import { Grid, Text } from "@pushpress/shared-components"; // replace 'your-library' with the actual library you're using
import styles from "./PlanList.module.scss"; // replace with your actual css module file

const PlanListLoader = () => {
  return (
    <React.Fragment>
      <div
        className={`${styles.listHeader} ${styles.firstListHeader} `}
        data-cy="list-item-category"
      >
        <Text variant="body-lg" color="wolf-800" weight="600">
          <Skeleton width={200} height={22} />
        </Text>
      </div>
      <li className={styles.listItem} data-cy="list-item-row">
        <Grid item xs={4} container justifyContent="center" direction="column">
          <Text variant="body-lg" color="wolf-800">
            <Skeleton width={350} height={22} />
          </Text>
        </Grid>
        <Grid item xs={3} container justifyContent="center" direction="column">
          <Text variant="body-lg" color="wolf-800">
            <Skeleton width={100} height={22} />
          </Text>
        </Grid>
        <Grid item xs={3} container alignItems="center">
          <Skeleton width={100} height={22} />
        </Grid>
        <Grid
          item
          xs={2}
          container
          alignItems="center"
          justifyContent="flex-end"
        >
          <Skeleton width={24} height={22} />
        </Grid>
      </li>
    </React.Fragment>
  );
};

export default PlanListLoader;
